/** Bounds of a Clarity fly-in the reader resizes, in px; the upper bound is a share of the viewport width. */
export const CLARITY_FLY_IN_RESIZE = {
	MIN_WIDTH: 336,
	WIDE_MIN_WIDTH: 471,
	MAX_VIEWPORT_SHARE: 0.8,
	KEYBOARD_STEP: 32,
} as const;

export const CLARITY_FLY_IN_RESIZE_TEXT = {
	LABEL: 'Resize panel',
} as const;
